import React, { useEffect } from 'react';
import { useActiveService } from 'hooks/useActiveService';
import { useLocation, useHistory } from 'react-router-dom';
import * as localStorage from '../../hooks/localStorage';
import { serviceContextKey } from 'constants/contexts';
import { useApolloClient } from '@apollo/client';
import menuConfig from 'constants/menuConfig';

export const getServiceFromRoute = (pathName, services) => {
  const filteredService = services.filter(x => pathName.includes(x.route));
  return filteredService[0];
};

const getServiceNameFromRoute = path => {
  const pathname = path.startsWith('/') ? path.slice(1) : path;
  const serviceName = pathname.split('/')[0];
  return serviceName;
};

export const onSetActiveService = (service, setActiveService, client) => {
  localStorage.setItem(serviceContextKey, service);
  setActiveService(service);
  client.resetStore();
};

const syncUrlWithService = (service, history) => {
  const serviceNameIsNotShownInUrl = menuConfig.some(z => window.location.pathname.includes(z.path));
  if (serviceNameIsNotShownInUrl) return;

  const serviceName = getServiceNameFromRoute(window.location.pathname);
  if (serviceName === service.route) return;

  const newPath = window.location.pathname.replace(serviceName, service.route);
  const queryString = window.location.search;
  const fullPath = `${newPath}${queryString}`;
  history.replace(fullPath);
};

const GlobalContextSetter = () => {
  const location = useLocation();
  const { activeService, setActiveService, services } = useActiveService();
  const client = useApolloClient();
  const history = useHistory();

  useEffect(() => {
    if (!services || services.length === 0) return;

    if (activeService) {
      //set received context
      const service = activeService.name
        ? services.find(z => z.name === activeService.name)
        : services.find(z => z.route === activeService.route);

      if (service) {
        if (activeService.name === service.name) return;
        onSetActiveService(service, setActiveService, client);
        return;
      }
    }

    // check if the current route contains a service
    const service = getServiceFromRoute(location.pathname, services);
    if (service) {
      onSetActiveService(service, setActiveService, client);
      return;
    }

    // check if there is a persisted service context
    const persistedServiceContext = localStorage.getItem(serviceContextKey);
    if (persistedServiceContext) {
      // validate persisted context
      const persistedService = services.find(z => z.name === persistedServiceContext.name && z.route === persistedServiceContext.route);
      if (persistedService) {
        // persisted service is valid
        syncUrlWithService(persistedService, history);
        setActiveService(persistedServiceContext);
        client.resetStore();
        return;
      } else {
        // persisted service is invalid and should be removed
        localStorage.removeItem(serviceContextKey);
      }
    }

    const fallbackService = services[0];
    syncUrlWithService(fallbackService, history);
    onSetActiveService(fallbackService, setActiveService, client);
  }, [services, setActiveService, activeService, location.pathname, client, history]);

  return <></>;
};

export default GlobalContextSetter;
